import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

$( '.carousel' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		loop: true,
		pagination: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 50,
		grabCursor: true,
		speed: 1000,
	} );
} );

